export default __webpack_public_path__ + "static/media/practice.26ab2fd9.svg";